import { default as multiSelection } from './multiSelection.handlebars';
import { default as singleSelection } from './singleSelection.handlebars';

export {
  multiSelection,
  singleSelection
};


/** WEBPACK FOOTER **
 ** ./src/UIs/default/layout/index.js
 **/